function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHourglasslow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.654 2.654A1.55 1.55 0 016.75 2.2h10.5a1.55 1.55 0 011.55 1.55v3.341a1.55 1.55 0 01-.615 1.237L13.327 12l4.858 3.672a1.552 1.552 0 01.615 1.235v3.343a1.55 1.55 0 01-1.55 1.55H6.75a1.55 1.55 0 01-1.55-1.55v-3.375a1.55 1.55 0 01.62-1.24L10.667 12 5.82 8.365a1.55 1.55 0 01-.62-1.24V3.75c0-.411.163-.805.454-1.096zM6.8 3.8v3.3l5.198 3.899L17.2 7.066V3.8H6.8zm0 13.877V20.2h10.4v-2.494l-10.4-.029zm9.302-1.574l-8.21-.023 4.106-3.079 4.104 3.102z",
    fill: props.fill
  }));
}

export default SvgHourglasslow;